export const LS_WECHAT_USER_INFO_KEY = '$WECHAT_USER_INFO'
export const ACCESS_KEY =
    (process.env.VUE_APP_SITE_ID || '') + '$ACCESS_CHECK_FAILED'
